import styles from './WeeklyReviewWizard.module.css'

interface RatingScaleProps {
  legend: string
  low: string
  high: string
  min: number
  max: number
  value: number | undefined
  onChange: (value: number) => void
}

/**
 * A 1–5 row for one recovery item.
 *
 * The two ends are labelled in words, always. Every item is phrased so 5 is the
 * better outcome (D-066) — including the two whose plain reading is inverted,
 * asked as "hunger control" and "calm" — and a bare row of numbers would leave
 * the user to guess which end is which. That guess is exactly what the phrasing
 * decision exists to remove, so the wording travels with the control.
 *
 * Buttons rather than a range slider: a slider gives no discrete target worth
 * 44 px, and drag is a poor one-handed gesture on a phone.
 */
export function RatingScale({ legend, low, high, min, max, value, onChange }: RatingScaleProps) {
  const values = Array.from({ length: max - min + 1 }, (_, index) => min + index)

  return (
    <fieldset class={styles.scale}>
      <legend class={styles.scaleLegend}>{legend}</legend>
      <div class={styles.scaleEnds}>
        <span>
          {min} — {low}
        </span>
        <span>
          {max} — {high}
        </span>
      </div>
      <div class={styles.scaleButtons}>
        {values.map((option) => (
          <button
            key={option}
            type="button"
            class={`${styles.scaleButton} ${value === option ? styles.scaleButtonSelected : ''}`}
            aria-pressed={value === option}
            /* The number alone would read as "1" to a screen reader with no
               indication of what it rates or which direction is better. */
            aria-label={`${legend}: ${option} of ${max}, where ${max} is ${high}`}
            onClick={() => onChange(option)}
          >
            {option}
          </button>
        ))}
      </div>
    </fieldset>
  )
}
